// extracted by mini-css-extract-plugin
module.exports = {"totalItem":"OrderDetailsTaxes_totalItem__2zC6s","number":"OrderDetailsTaxes_number__gAY7H"};